import { render, staticRenderFns } from "./contact-phones-emails.vue?vue&type=template&id=74c4e83e&"
import script from "./contact-phones-emails.vue?vue&type=script&lang=js&"
export * from "./contact-phones-emails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports